import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { BUSINESS } from "../constants/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t hairline bg-[color:var(--surface)]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-16 sm:py-20 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <img src={BUSINESS.logo} alt="Creative Designs Services" className="h-24 w-auto mb-6" />
          <p className="text-[color:var(--text-2)] max-w-sm leading-relaxed">
            {BUSINESS.subtitle}. Turning pressure into polished, print-ready results — from stress to success.
          </p>
          <p className="font-display italic text-2xl text-gradient-gold mt-6">{BUSINESS.tagline}</p>
        </div>

        <div>
          <h4 className="font-mono-x text-[11px] tracking-[0.3em] uppercase text-[color:var(--gold)] mb-6">Explore</h4>
          <ul className="space-y-3 text-[color:var(--text-2)]">
            {["Services", "About", "Portfolio", "Contact"].map((l) => (
              <li key={l}>
                <Link to={`/${l.toLowerCase()}`} className="link-underline hover:text-[color:var(--text)] transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono-x text-[11px] tracking-[0.3em] uppercase text-[color:var(--gold)] mb-6">Get in touch</h4>
          <ul className="space-y-4 text-[color:var(--text-2)]">
            <li className="flex items-start gap-3">
              <EnvelopeSimple size={18} className="text-[color:var(--gold)] mt-0.5" />
              <a href={`mailto:${BUSINESS.email}`} className="break-all hover:text-[color:var(--text)] transition-colors">{BUSINESS.email}</a>
            </li>
            {BUSINESS.phones.map((p) => (
              <li key={p} className="flex items-center gap-3">
                <Phone size={18} className="text-[color:var(--gold)]" />
                <a href={`tel:${p.replace(/-/g, "")}`} className="hover:text-[color:var(--text)] transition-colors">{p}</a>
              </li>
            ))}
            <li className="flex items-center gap-3">
              <MapPin size={18} className="text-[color:var(--gold)]" />
              <span>{BUSINESS.location}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t hairline">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[color:var(--muted)]">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
          <span className="font-mono-x tracking-wider">{BUSINESS.domain}</span>
        </div>
      </div>
    </footer>
  );
}
